import moment from 'moment';
import React from 'react';
import { uniqBy } from 'lodash';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';

import { env } from '~/commons/config';

import ListResource from './ListResource.jsx';

const api = '/api/core/users/customers';

const ListCustomers = ({ showrooms }) => {
  const showrms = uniqBy(showrooms, 'orgId');

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'all', label: 'All' },
          { value: 'erpId', label: 'ERP ID' },
          {
            value: 'orgId',
            label: 'Org ID',
            options: showrms.map((s) => ({
              value: s.orgId,
              label: `${s.orgId} - ${s.name}`,
            })),
          },
          {
            value: 'erpSync.success',
            label: 'Success Sync',
            options: [
              { value: 1, label: 'True' },
              { value: 0, label: 'False' },
            ],
          },
        ],
        api,
        sort: { 'name.full.en': 1 },
        actions: {
          fileImport: { accept: '.json' },
        },
        cols: [
          { key: 'name.full.en', sortable: true, children: 'English Name' },
          { key: 'name.full.zhHant', sortable: true, children: 'Chinese Name' },
          { key: 'orgId', children: 'Org ID' },
          { key: 'mobile.number', children: 'Mobile' },
          { key: 'orderSpent', sortable: true },
          {
            key: 'orderLatest',
            sortable: true,
            getter: (v) => (v ? moment(v).format(env.f.d) : ''),
          },
          { key: 'source', sortable: true },
          {
            key: 'erpSync.lastSync',
            sortable: true,
            children: 'Last Sync Attempt',
            getter: (v) => (v ? moment(v).format(env.f.dt) : ''),
          },
          {
            key: 'erpSync.success',
            sortable: true,
            children: 'Success',
            getter: (v) => (typeof v === 'string' ? v : <FA icon={v ? faCheckCircle : faTimesCircle} />),
          },
        ],
      }} />
  );
};

export default ListCustomers;
